/* eslint-disable arrow-body-style */
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { ToggleButtonGroup as MuiToggleButtonGroup } from '@mui/material';

const StyledToggleButtonGroup = styled(MuiToggleButtonGroup)`
  &.Mui-disabled {
    color: ${({ theme }) => theme.palette.grey[5]};
  }
`;

/**
* Renders a <ToggleButtonGroup /> component. Property 'value' will hold the clicked ToggleButton value,
* if set on each child ToggleButton
* @param {Object} props
* @param {node | node[]} props.children - Children for the group, should be <ToggleButton> components
*/
export const ToggleButtonGroup = ({ children, ...rest }) => {
  return (
    <StyledToggleButtonGroup
      exclusive
      {...rest}
    >
      {children}
    </StyledToggleButtonGroup>
  );
};

ToggleButtonGroup.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};
